import React from 'react';
import Icon from '../../../components/AppIcon';

const ServiceProcess = ({ steps }) => {
  return (
    <div className="bg-white rounded-xl shadow-elevation-2 p-8 border border-border">
      <div className="text-center mb-8">
        <h2 className="text-2xl font-bold text-text-primary mb-2">
          Our Service Process
        </h2>
        <p className="text-text-secondary">
          Here's how we deliver exceptional cleaning results every time
        </p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {steps?.map((step, index) => (
          <div key={index} className="relative">
            {/* Step Number */}
            <div className="flex items-center mb-4">
              <div className="w-12 h-12 bg-primary rounded-full flex items-center justify-center text-white font-bold text-lg relative z-10">
                {index + 1}
              </div>
              {index < steps?.length - 1 && (
                <div className="hidden lg:block absolute left-12 top-6 w-full h-0.5 bg-border -z-10" />
              )}
            </div>
            
            {/* Step Content */}
            <div className="space-y-3">
              <div className="w-16 h-16 bg-primary/10 rounded-lg flex items-center justify-center">
                <Icon name={step?.icon} size={24} color="var(--color-primary)" />
              </div>
              
              <h3 className="text-lg font-semibold text-text-primary">
                {step?.title}
              </h3>
              
              <p className="text-text-secondary text-sm leading-relaxed">
                {step?.description}
              </p>
              
              {step?.duration && (
                <div className="flex items-center space-x-2 text-xs text-text-secondary">
                  <Icon name="Clock" size={14} />
                  <span>{step?.duration}</span>
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
      {/* Process Guarantee */}
      <div className="mt-8 bg-success/10 rounded-lg p-6 border border-success/20">
        <div className="flex items-center space-x-3">
          <div className="w-12 h-12 bg-success rounded-lg flex items-center justify-center">
            <Icon name="Shield" size={24} color="white" />
          </div>
          <div>
            <h4 className="font-semibold text-text-primary">100% Satisfaction Guarantee</h4>
            <p className="text-sm text-text-secondary">
              If you're not completely satisfied with our service, we'll return to make it right at no extra cost.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServiceProcess;